import React, { Component } from 'react';
import Header from '.././Header';
import classnames from 'classnames';

import './style.sass';

export default class About extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    const { className } = this.props;
    return (
      <div className={classnames('About', className)}>
        <div className="container">
          <Header />
          <div className="About-body">
            <p className="highlight">Hello, I'm Kah. </p>
            <p>
              I'm a product designer at AngelList. I currently design and build products for a marketplace of recruiting startups and job seekers.
            </p>
            <p>
              Previously, I spent three years as a product designer at Quora after joining as the first product design intern. I graduated from the National University of Singapore with a Bachelor of Computing.
            </p>
            <p>
              I enjoy working on side projects in my spare time. My past endeavors include building a mobile survey tool for businesses, organizing startup miniconferences at Stanford University, running a microblogging platform, and starting a private tutor agency.
            </p>
            <p>
              I'm also passionate about communities and bringing people closer. I've been involved with the Singaporean community in the bay area since 2011 through SG Founders and Bay Area Tech Singaporeans.
            </p>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/About/index.js